import EventIcon from './EventIcon';

export default EventIcon;
